import { AxiosInstance } from 'axios';
import { z } from 'zod';

import { ReservationIDType } from '^/types/__BrandedTypes';
import { asFailedPromise, asSuccessPromise } from '^/types/__ResultType';

import { api2BaseAxios } from '../api2BaseAxios';
import { zodValidateAxiosResp } from '../zodValidate';

const ReservationCancelCheckResponse = z.object({
  status: z.union([z.literal(200), z.literal(201)]),
  data: z.object({
    cancel_reason: z.string(),
    cancellation_fee_amount: z.number(),
    cancel_policy: z.string(),
    free_cancelable_date: z.string().nullable(),
    free_cancelable_date_with_datetime: z.string().nullable(),
    refund_price: z.number(),
  }),
});

const validator = zodValidateAxiosResp(ReservationCancelCheckResponse, (err) => {
  console.error('reservationCancelCheck zodError', err);
});

export function createReservationCancelCheckAPI(axiosInstance: AxiosInstance) {
  return async function reservationCancelCheckAPI(args: { reservation_id: ReservationIDType }) {
    const rawResponse = await axiosInstance.get('/v2/reservation/cancel-check', {
      params: {
        reservation_id: args.reservation_id,
      },
    });

    const validated = validator(rawResponse);
    if (validated.data.status !== 200 && validated.data.status !== 201) {
      return asFailedPromise({
        reason: 'HTTPError',
        error: rawResponse.data,
        rawResponse,
      } as const);
    }

    return asSuccessPromise({
      ...validated.data,
      zodError: validated.ZOD_ERROR,
      zodValidation: validated.ZOD_VALIDATION,
    });
  };
}

export const reservationCancelCheckAPI = createReservationCancelCheckAPI(api2BaseAxios);

export type ReservationCancelCheckAPIType = typeof reservationCancelCheckAPI;
